export const STORE_DISABLED = "store_disabled";
export const MENU_UPDATE_DISABLED = "menu_update_disabled";
